export { DigFileItemComponent } from "./file-item.component";
